// instancias.ts
import axios, { AxiosInstance } from "axios";
import { responseInterceptorError, responseInterceptorSuccess } from "./Interceptores";

export const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// registra los interceptores sobre la instancia
api.interceptors.response.use(responseInterceptorSuccess, responseInterceptorError);
